/*
<summary>
   This file is used to provide initial values or state to the AddProcessForm.
   Developer:Urvashi, Created Date: 21-November-2024
</summary>
*/
import { IAddDefectiveItem } from '../../models/forms/IAddUpdateDefectiveItem';
const initialProcessState: IAddDefectiveItem = {
  Id: -1,
  Subject: '',
  Item: '',
  Classification1: '',
  Classification2: '',
  Comments: '',
  TenantId: 0,
};

export default initialProcessState;
